import { render } from "./tree-item.vue?vue&type=template&id=1c21a192&scoped=true"
import script from "./tree-item.vue?vue&type=script&lang=js"
export * from "./tree-item.vue?vue&type=script&lang=js"

import "./tree-item.vue?vue&type=style&index=0&id=1c21a192&scoped=true&lang=css"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c21a192"]])

export default __exports__